import { PDSProvider } from "@preownedfront/lib-reowds";
import { QueryClientProvider } from "@tanstack/react-query";
import { ZDSProvider } from "@zarafront/lib-zds";
import i18next from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import MainHeader from "src/components/Layout/MainHeader";
import { queryClient } from "src/utils/init/queryClient";
import "./assets/styles/styles.scss";
import { routes } from "./modules";
import { getCurrentBasePath } from "./utils/BasePathTools";
import { GrowthBookProvider } from "./utils/growthBook/growthbook";
import { ApplicationInitializerProvider } from "./utils/providers/ApplicationInitializerProvider";
import { GoogleMapsProvider } from "./utils/providers/GoogleMapsProvider";
import { NavigationHistoryProvider } from "./utils/providers/NavigationHistoryProvider";
import { ScriptsLoader } from "./utils/scripts/ScriptsLoader";
import { UpdateLanguage } from "./utils/updateLangue";

ReactDOM.render(
  <ZDSProvider
    dir="ltr"
    theme={{ mode: "light" }}
    toast={{ notificationsAriaLabel: "notificationsAriaLabel" }}
  >
    <PDSProvider dir="ltr" theme={{ mode: "light" }}>
      <Router basename={getCurrentBasePath()}>
        <QueryClientProvider client={queryClient}>
          <NavigationHistoryProvider>
            <MainHeader>
              <ApplicationInitializerProvider>
                <GrowthBookProvider>
                  <GoogleMapsProvider>
                    <ScriptsLoader>
                      <I18nextProvider i18n={i18next}><UpdateLanguage />{routes}</I18nextProvider>
                    </ScriptsLoader>
                  </GoogleMapsProvider>
                </GrowthBookProvider>
              </ApplicationInitializerProvider>
            </MainHeader>
          </NavigationHistoryProvider>
        </QueryClientProvider>
      </Router>
    </PDSProvider>
  </ZDSProvider>,
  document.getElementById("app") || document.createElement("div"),
);
